<section class="login-shell">
  <div class="login-frame">
    <aside class="login-left">
      <div class="login-brand">
        <span class="login-brand__frame">
          <img class="login-brand__img" src="/assets/images/logo.png" alt="Careergrad Global logo" />
        </span>
        <span class="login-brand__wordmark">Careergrad Global</span>
      </div>

      <h1 class="login-left__title">Accelerate Your Career Journey</h1>

      <ul class="login-benefits">
        <li><app-admin-icon name="circle-check-big" [size]="18"></app-admin-icon> Track leads and applications</li>
        <li><app-admin-icon name="circle-check-big" [size]="18"></app-admin-icon> Manage student enrollments</li>
        <li><app-admin-icon name="circle-check-big" [size]="18"></app-admin-icon> Monitor franchise performance</li>
        <li><app-admin-icon name="circle-check-big" [size]="18"></app-admin-icon> Real-time analytics</li>
      </ul>

      <figure class="login-left__visual">
        <img src="/assets/images/login.jpg" alt="" />
      </figure>
    </aside>

    <main class="login-right">
      <div class="login-right__body">
        <span class="login-lock">
          <app-admin-icon name="lock" [size]="28"></app-admin-icon>
        </span>

        <h2 class="login-right__title">Welcome Back</h2>
        <p class="login-right__subtitle">
          <span>Login for Admin and Franchise Staff</span><br />
          <strong>Click the Continue with Google button below to login.</strong>
        </p>

        <div class="login-google-wrap">
          <div id="googleSignInButton"></div>
        </div>

        <p class="login-divider"><span>SECURE ACCESS</span></p>
        <p class="login-terms">By signing in, you agree to our <a href="#">Terms of Service</a> and <a href="#">Privacy Policy</a>.</p>

        @if (loading()) {
          <p class="login-feedback">Authenticating...</p>
        }

        @if (errorMessage()) {
          <p class="login-feedback login-feedback--error">{{ errorMessage() }}</p>
        }
      </div>

      <footer class="login-footer">
        <span>&copy; 2026 Careergrad Global (A Unit of of SkillSpring Ventures LLP)</span>
        <a href="#">Support</a>
        <a href="#">Documentation</a>
      </footer>
    </main>
  </div>
</section>
